/* SEARCH-04. Подкласс DetailsModal для `.amore-frame-search` — по образцу
   `password-modal.js`. details-modal.js (чужой, стоковый) не трогается.

   Причина: словесная кнопка `[data-amore-search-word-open]`
   (`amore-frame.js`) кликает родную `<summary>` программно, чтобы
   получить весь путь `details-modal.js` (trapFocus, блокировка прокрутки,
   закрытие по клику вовне) бесплатно. Но кнопка физически лежит ВНЕ
   `<details-modal>` (сосед в `.amore-frame-header__right`, а не потомок).
   Реальный клик по ней всплывает до `document.body` уже ПОСЛЕ вложенного
   синтетического клика по summary — то есть после того, как
   `details-modal.js:open()` успел повесить свой обработчик на body. Тот же
   обработчик получает этот всплывающий клик, видит `event.target` — саму
   кнопку, не потомка `<details-modal>` — и закрывает панель в тот же тик.

   Правка — тонкая: собственный триггер панели не считается кликом вовне.
   Остальное поведение (клик по оверлею, клик где угодно ещё) не меняется —
   вызывается родная логика через super(). */
class AmoreSearchModal extends DetailsModal {
  onBodyClick(event) {
    if (event.target.closest('[data-amore-search-word-open]')) return;
    super.onBodyClick(event);
  }
}

/* Guard нужен именно здесь (в отличие от `password-modal.js`, который
   грузится один раз статикой в `layout/password.liquid`): этот скрипт
   подключён из секции шапки, а секции Shopify-редактор может
   переинициализировать при живом редактировании настроек, из-за чего
   тег script выполнится повторно и `customElements.define` бросит
   исключение на второй вызов. Тот же приём уже есть в теме —
   `golden-pdp.js`, `amore-pdp.js`. */
if (!customElements.get('amore-search-modal')) {
  customElements.define('amore-search-modal', AmoreSearchModal);
}
